__turbopack_context__.v({
  "container": "D5nTzG_container",
  "desktopLabel": "D5nTzG_desktopLabel",
  "desktopLogo": "D5nTzG_desktopLogo",
  "headerAppBar": "D5nTzG_headerAppBar",
  "languageIcon": "D5nTzG_languageIcon",
  "mobileLabel": "D5nTzG_mobileLabel",
  "mobileLogo": "D5nTzG_mobileLogo",
});
